import { getClientFinanceSummary, GetClientFinanceSummaryResponse } from '../api';
import { useLocation } from 'react-router-dom';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

interface UseClientFinanceSummaryRequest {
  orgId: string | null | undefined;
}

export const useClientFinanceSummary = (
  payload: UseClientFinanceSummaryRequest
): UseQueryResult<GetClientFinanceSummaryResponse, Error> => {
  const {
    orgId
  } = payload;

  const location = useLocation();
  const clientOrgId = orgId ?? '';

  return useQuery({
    enabled: Boolean(orgId),
    queryFn: () => getClientFinanceSummary({ orgId: clientOrgId }),
    queryKey: ['getClientFinanceSummary', location.pathname, orgId],
    retry: 1
  });
};